import React, { useState } from 'react';
import { Row, Col, Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { getPreferredLanguage, setApiLanguageHeader, SUPPORTED_LANGUAGES } from "../../../utils/language";
import { useDispatch, useSelector } from "react-redux";
import { updatePreferences } from "../../../redux/slices/userSlice";
import { getTimeFormatPreference, setTimeFormatPreference, TIME_FORMATS } from "../../../utils/timeFormat";

const LanguageArea = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const savedTimeFormat = useSelector((state) => state.auth.user?.preferences?.time_format);
    
    const [selectedLang, setSelectedLang] = useState(getPreferredLanguage());
    const [timeFormat, setTimeFormat] = useState(() => savedTimeFormat || getTimeFormatPreference());

    const handleSave = async () => {
        i18n.changeLanguage(selectedLang);
        setApiLanguageHeader(selectedLang);
        
        const normalizedTimeFormat = setTimeFormatPreference(timeFormat);
        await dispatch(updatePreferences({ time_format: normalizedTimeFormat })).unwrap();
        
        toast.success(t('components.LanguageArea.save_changes') + "!");
    };

    return (
        <div className="pt-4 pb-5">
            <Row className="gx-5">
                <Col md={8} className="mb-5">
                    <h4 className="txt-main fw-bold mb-2">{t('components.LanguageArea.title')}</h4>
                    <p className="txt-subtle mb-4" style={{ fontSize: '0.95rem' }}>
                        {t('components.LanguageArea.description')}
                    </p>

                    <Form>
                        <Form.Group className="mb-5">
                            {SUPPORTED_LANGUAGES.map(language => (
                                <div
                                    key={language.code}
                                    className={`p-3 mb-3 rounded-3 d-flex align-items-center ${selectedLang === language.code ? 'border-primary' : ''}`}
                                    style={{
                                        border: selectedLang === language.code ? '2px solid var(--brand-primary)' : '1px solid var(--gray-300)',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        backgroundColor: selectedLang === language.code ? 'rgba(255, 57, 57, 0.05)' : 'transparent'
                                    }}
                                    onClick={() => setSelectedLang(language.code)}
                                >
                                    <Form.Check
                                        type="radio"
                                        id={`lang-${language.code}`}
                                        name="language"
                                        value={language.code}
                                        checked={selectedLang === language.code}
                                        onChange={(e) => setSelectedLang(e.target.value)}
                                        className="mb-0 me-3"
                                    />
                                    <span className="txt-main fw-bold" style={{ fontSize: '1.1rem' }}>
                                        {t(language.labelKey, language.fallbackLabel)}
                                    </span>
                                </div>
                            ))}
                        
                        </Form.Group>

                        <Form.Group className="mb-5">
                            <Form.Label className="txt-main fw-bold">{t('components.LanguageArea.time_format_title')}</Form.Label>
                            <Form.Text className="d-block txt-subtle mb-3">{t('components.LanguageArea.time_format_description')}</Form.Text>
                            {[
                                [TIME_FORMATS.SYSTEM, t('components.LanguageArea.time_format_system')],
                                [TIME_FORMATS.TWELVE_HOUR, t('components.LanguageArea.time_format_12h')],
                                [TIME_FORMATS.TWENTY_FOUR_HOUR, t('components.LanguageArea.time_format_24h')],
                            ].map(([value, label]) => (
                                <Form.Check
                                    key={value}
                                    type="radio"
                                    name="time-format"
                                    id={`time-format-${value}`}
                                    label={label}
                                    value={value}
                                    checked={timeFormat === value}
                                    onChange={(event) => setTimeFormat(event.target.value)}
                                    className="mb-2"
                                />
                            ))}
                        </Form.Group>
                        
                        <Button className="btn btn-primary px-5 py-2 fw-bold" onClick={handleSave}>
                            {t('components.LanguageArea.save_changes')}
                        </Button>
                    </Form>
                </Col>
            </Row>
        </div>
    );
};

export default LanguageArea;
